import { NodeModel } from 'mrblenny-storm-react-diagrams'
import { CustomPortModel } from './CustomPortModel'
import { nodes } from '../Flow.data'

export class CustomNodeModel extends NodeModel {
  constructor(nodeType) {
    super(nodeType)
    const info = nodes[nodeType]

    if (info) {
      info.inputs.forEach((val, idx) => this.addPort(new CustomPortModel(`input-${idx}`, 'input')))
      info.outputs.forEach((val, idx) =>
        this.addPort(new CustomPortModel(val.name || `output-${idx}`, 'output'))
      )
    }
  }
}

// canLinkToPort(port: PortModel): boolean {
//   if (port instanceof DefaultPortModel) {
//     return this.in !== port.in;
//   }
//   return true;
// }



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/CustomNode/CustomNodeModel.js